import { createSlice } from "@reduxjs/toolkit";
import { addTimeSlot, deleteTimeSlot, getWeeklyClassesForSection } from "../services/timeSlot_service";

// ----------------------------------------------------------------------

const slice = createSlice({
    name: "timeSlot",

    initialState: {
        isLoadingWeeklyClassForSection: false,
        isLoadingAddTimeSlot: false,
        isLoadingDeleteTimeSlot: false,
        weeklyClasses: {},
    },

    reducers: {

    },

    extraReducers: {
        //GET  ==> get getWeeklyClassesForSection
        [getWeeklyClassesForSection.fulfilled]: (state, action) => {
            state.isLoadingWeeklyClassForSection = false;
            state.weeklyClasses = action.payload.data;
        },
        [getWeeklyClassesForSection.rejected]: (state, action) => {
            state.isLoadingWeeklyClassForSection = false;
        },
        [getWeeklyClassesForSection.pending]: (state) => {
            state.isLoadingWeeklyClassForSection = true;
        },

        //POST  ==> addTimeSlot
        [addTimeSlot.fulfilled]: (state, action) => {
            state.isLoadingAddTimeSlot = false;
        },
        [addTimeSlot.rejected]: (state, action) => {
            state.isLoadingAddTimeSlot = false;
        },
        [addTimeSlot.pending]: (state) => {
            state.isLoadingAddTimeSlot = true;
        },

        //DELETE  ==> deleteTimeSlot
        [deleteTimeSlot.fulfilled]: (state, action) => {
            state.isLoadingDeleteTimeSlot = false;
        },
        [deleteTimeSlot.rejected]: (state, action) => {
            state.isLoadingDeleteTimeSlot = false;
        },
        [deleteTimeSlot.pending]: (state) => {
            state.isLoadingDeleteTimeSlot = true;
        },


    },
});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;
